import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { AppRoutingModule } from './app-routing.module';
import { NavigationComponent } from './components/navigation/navigation.component';
import { HistoryComponent } from './pages/history/history.component';
import { ExperienceComponent } from './pages/experience/experience.component';
import { MissionVisionComponent } from './pages/mission-vision/mission-vision.component';
import { OfferedServicesComponent } from './pages/offered-services/offered-services.component';
import { ProjectsImportantComponent } from './pages/projects-important/projects-important.component';
import { OurCustomersComponent } from './pages/our-customers/our-customers.component';
import { OurProposalComponent } from './pages/our-proposal/our-proposal.component';
import { ApiService } from './services/api.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomerBoxComponent } from './components/customer-box/customer-box.component';
import { LoginComponent } from './pages/login/login.component';
import { FormsModule } from '@angular/forms';
import { AdminAreaComponent } from './pages/admin-area/admin-area.component';
import { HttpConfigInterceptor } from './auth/httpconfig.interceptor';
import { Translate } from './pipe/translate.pipe';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { InfoCookiesComponent } from './pages/infor-cookies/infor-cookies.component';
import { FooterComponent } from './components/footer/footer.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { WorkWithUsComponent } from './pages/work-with-us/work-with-us.component';
import { HomepageManagementComponent } from './pages/admin-area/areas/homepage-management/homepage-management.component';
import { CustomerManagementComponent } from './pages/admin-area/areas/customer-management/customer-management.component';
import { ProjectsManagementComponent } from './pages/admin-area/areas/projects-management/projects-management.component';
import { WorkWithUsManagementComponent } from './pages/admin-area/areas/work-with-us-management/work-with-us-management.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { QuillModule } from 'ngx-quill';
import { CookiesModalComponent } from './components/cookies-modal/cookies-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LoaderComponent } from './components/loader/loader.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { WhoWeAreComponent } from './pages/who-we-are/who-we-are.component';
// import {NgbCarousel, NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    NavigationComponent,
    HistoryComponent,
    ExperienceComponent,
    MissionVisionComponent,
    OfferedServicesComponent,
    ProjectsImportantComponent,
    OurCustomersComponent,
    OurProposalComponent,
    CustomerBoxComponent,
    LoginComponent,
    AdminAreaComponent,
    Translate,
    PrivacyComponent,
    InfoCookiesComponent,
    FooterComponent,
    AboutUsComponent,
    ContactsComponent,
    WorkWithUsComponent,
    HomepageManagementComponent,
    CustomerManagementComponent,
    ProjectsManagementComponent,
    WorkWithUsManagementComponent,
    CookiesModalComponent,
    LoaderComponent,
    GalleryComponent,
    WhoWeAreComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    QuillModule.forRoot(),
    DragDropModule,
    // NgbModule,
    // NgbCarousel
  ],
  providers: [
    ApiService,
    AuthGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    Translate
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
